export enum TenantActionTypes {
  SET_TENANT = 'SET_TENANT',
  SET_AVAILABLE_TENANTS = 'SET_AVAILABLE_TENANTS',
  SET_CURRENT_TENANT_ID = 'SET_CURRENT_TENANT_ID',
  GET_TENANT_FAILED = 'GET_TENANT_FAILED',
  TENANT_LOADING = 'TENANT_LOADING',
  TENANT_CLEANUP = 'TENANT_CLEANUP',
  UPDATE_TENANT = 'UPDATE_TENANT',
  CLEAR_TENANT = 'CLEAR_TENANT',
  CLEAR_ALL_TENANTS = 'CLEAR_ALL_TENANTS',
}
